import * as types from "../actions/actionTypes";
import log from "../utils/log";

export const requestLogin = () => {
  log.info("[LOGIN ACTION] REQUEST_LOGIN");
  return {
    type: types.REQUEST_LOGIN
  };
};

export const requestLogout = () => {
  log.info("[LOGIN ACTION] REQUEST_LOGOUT");
  return {
    type: types.REQUEST_LOGOUT
  };
};

export const loginSuccess = (token) => {
  log.info("[LOGIN ACTION] LOGIN_SUCCESS");
  return {
    type: types.LOGIN_SUCCESS,
    token
  };
};

export const loginFail = () => {
  log.info("[LOGIN ACTION] LOGIN_FAIL");
  return {
    type: types.LOGIN_FAIL
  };
};
export const logoutSuccess = () => {
  log.info("[LOGIN ACTION] LOGOUT_SUCCESS");
  return {
    type: types.LOGOUT_SUCCESS
  };
};
export const logoutFail = () => {
  log.info("[LOGIN ACTION] LOGOUT_FAIL");
  return {
    type: types.LOGOUT_FAIL
  };
};



// WEBPACK FOOTER //
// ./src/actions/loginActions.js